const styles = () => ({
  pagination: {
    marginTop: '20px',
    display: 'flex',
    justifyContent: 'center'
  }
})

export default styles
